import type { GetServerSideProps } from 'next';

import { withFixedPageCommonProps } from '@/utils/fixedPage';
import { getLocaleFromParams } from '@/utils/locale';

import {
  fetchCMSDefaultConfig,
  fetchFixedPageData,
  fetchNewsPages,
} from '@/integrations/contentful';
import { commonServerSideProps } from '@/lib/commonPageStaticProps';
import { resolveContentDraftMode } from '@/lib/draftMode';
import { getGqlRegionFromLocale, getRegionFromLocale } from '@/lib/regions';
import { CacheHeaderType } from '@/lib/revalidate';
import { News } from '@/views/NewsView/News';

export const getServerSideProps: GetServerSideProps = commonServerSideProps(
  async (context) => {
    const routerLocale = getLocaleFromParams(context?.params);
    const { channel, languageCode } = getGqlRegionFromLocale(routerLocale);
    const { country, locale } = getRegionFromLocale(routerLocale);

    const draftMode = resolveContentDraftMode(context);
    const { cmsDefaultLayoutData } = await fetchCMSDefaultConfig(
      locale,
      country,
      draftMode,
    );

    const countryCode = country.slug;
    const contentfulLocale = locale.contentful ?? locale.locale;
    const data = await fetchFixedPageData(
      'news',
      contentfulLocale,
      languageCode,
      channel,
      countryCode,
      draftMode,
    );

    const getPages = await fetchNewsPages(
      contentfulLocale,
      countryCode,
      draftMode,
    );
    const newsPages = getPages.pageCollection?.items;

    return {
      props: {
        cms: data.cms,
        cmsDefaultLayoutData,
        newsPagesCollection: newsPages,
        seoConfig: data.seoConfigBuilder?.build(),
        draftMode: draftMode,
      },
    };
  },
  CacheHeaderType.FIXED_PAGE,
);

export default withFixedPageCommonProps(News);
